import {useQuery} from "react-query";
import Constants from "../../Utils/Constants";
import { OrganizationServices } from "../../Services/organizations";

export const useGetVendorFilters= (url, body) =>{
    return useQuery([Constants.REACT_QUERY.QUERY_KEY.GET_VENDORS],()=> OrganizationServices.getTotalOrganizations(url, body),{
        staleTime:1000,
        enabled:body!==null,
        refetchOnMount:true
    })
}